module.exports = {
    "tel": "Tel",
    "email": "Email",
    "contact": "Contact Us",
    "search": "Search",
    "result": "Result",
    "search.placeholder": "Search...",
    "all": "all",
    "search.title": "title",
    "search.content": "content",
    "no.search.result": "If there is no result",
    "click": "please click",
    "post.topic": "New Topic",
    "new.question": "to submit question in forum",
    "qq": "QQ Group",
    "advance.search": "options",
    "search.field": "Field",
    "search.tags": "tag",
    "search.comments": "comment",
    "topic.type": "Type",
    "site": "site",
    "tut": "Tutorials",
    "topic.plate": "Plate"
}


// WEBPACK FOOTER //
// ./src/pages/search/i18n/locale.en.js